import React from 'react';

import CustomTooltip, { POSITIONS } from '@components/CustomTooltip';

import {
	isPack,
	isSetProduct,
	isTnaCompleated,
	PLANNING_STATUS,
	TNA_REQUEST_TYPE
} from '@features/order/utils/projectUtil';

import { convertDateToLocal, getShortName, packTag, renderSetImages, setTag, splitTag } from '@utils/Util';

const StyleCard = ({
	product,
	isSelected,
	onSelectProduct,
	showCheckBox = false,
	onCheckBoxChecked,
	checkedStyles,
	isCompleated
}) => {
	const areProductAndMembersCompleted = (product) => {
		if (isSetProduct(product) && Array.isArray(product?.setMemberList)) {
			return product?.setMemberList.every(
				(member) => member.planningStatus !== PLANNING_STATUS.PENDING
			);
		}
	};

	const renderIconBasedOnPlanningSource = (product) => {
		if (product.planningSource === TNA_REQUEST_TYPE.TEMPLATE) {
			return (
				<img src={`${process.env.PUBLIC_URL}/icons/Success.svg`} alt="success" className="select" />
			);
		} else {
			return (
				<img
					src={`${process.env.PUBLIC_URL}/images/icons/tna-upload-icon.svg`}
					alt="upload-success"
					className="select"
				/>
			);
		}
	};

	const renderSuccessIcon = (product) => {
		if (isSetProduct(product) && areProductAndMembersCompleted(product)) {
			return renderIconBasedOnPlanningSource(product);
		} else if (!isSetProduct(product) && isTnaCompleated(product)) {
			return renderIconBasedOnPlanningSource(product);
		} else {
			return null;
		}
	};
	return (
		<div
			className={`single-tab-item d-flex align-items-center ${isSelected ? 'active' : ''}`}
			onClick={() => !showCheckBox && onSelectProduct(product, '')}
		>
			{showCheckBox && !isCompleated && (
				<div className="custom-chekbox" style={{ zIndex: 999 }}>
					<div className="form-group">
						<input
							type="checkbox"
							id={`styleCheckBox_${product?.rfqId}`}
							name="styleCheckBox"
							value={product?.rfqId}
							onChange={(e) => {
								onCheckBoxChecked(parseInt(e.target.value), product?.rfqStatusInfoList || []);
							}}
							checked={checkedStyles.includes(product?.rfqId)}
						/>
						<label htmlFor={`styleCheckBox_${product?.rfqId}`}></label>
					</div>
				</div>
			)}
			<div className="item-image">
				{isSetProduct(product) && renderSetImages(product?.setMemberList, '100%')}
				{!isSetProduct(product) && (
					<img src={product?.image} alt={product?.name} className="thum-image" />
				)}
				{renderSuccessIcon(product)}
			</div>
			<div className="item-content pl-3">
				<div className="item-stauts d-flex">
					{isSetProduct(product) && setTag('mr-1')}
					{isPack(product) && packTag('mr-1')}
					{!product?.isBaseRfq && splitTag()}
				</div>
				<CustomTooltip
					text={`${product?.referenceNumber}`}
					position={POSITIONS.BOTTOM}
					arrowCenter={true}
				>
					<p className="gray_dark_01 regular-14 weight-500 mt-1">
						{getShortName(product?.referenceNumber, 10)}
					</p>
				</CustomTooltip>
				<CustomTooltip
					text={`${product?.supplierName}`}
					position={POSITIONS.BOTTOM}
					arrowCenter={true}
				>
					<p className="gray_dark_02 regular-12 mt-1"> {getShortName(product?.supplierName, 10)}</p>
				</CustomTooltip>
				<CustomTooltip text={'Factory ETD'} position={POSITIONS.TOP} arrowLeft={true}>
					<p className="gray_dark_01 regular-14 weight-500 mt-1">
						{convertDateToLocal(product?.factoryDeliveryDate, 'DD MMM YY')}
					</p>
				</CustomTooltip>
			</div>
		</div>
	);
};

export default StyleCard;
